import {
  CheckoutBlockType,
  DiscountApplicationTypeNotEmpty,
  ModKeys,
} from "@intelligems/ig-types";
import { OpenDialogAction } from "@src/store/slices/global";

export type OfferPreset = {
  discountType: DiscountApplicationTypeNotEmpty;
  discountMethod?: "perItem" | "perOrder";
  unitType?: "unit" | "dollar";
};

/** Which modification a create-experience card stands for. */
export type ExperienceModSpec =
  | { kind: "offer"; preset: OfferPreset }
  | {
      kind: "checkoutBlock";
      checkoutBlockType: CheckoutBlockType;
      checkoutBlockTemplate?: string;
    }
  | { kind: "postPurchase"; postPurchaseType: string };

/**
 * The modification a merchant already chose on a create-experience card, plus
 * that card's own title and description.
 */
export type ExperienceModPreset = ExperienceModSpec & {
  label: string;
  description: string;
};

export type AlertState = {
  key: string;
  customMessage?: string;
  docLink?: string;
  openDialog?: {
    linkText: string;
    payload?: OpenDialogAction["payload"];
  };
};

export type IExperienceInfoStateSlice = {
  alertOpen: boolean;
  warnings: AlertState[];
  errors: AlertState[];
  activatedModArr: ModKeys[];
  showErrors: boolean;
  activatedVariationMods: Record<
    string,
    {
      mods: ModKeys[];
    }
  >;
  creationModPreset: ExperienceModPreset | null;
  modsTabVariationId: string | null; // the group the Modifications tab shows
};

export const initialExperienceInfoStateSlice: IExperienceInfoStateSlice = {
  alertOpen: false,
  warnings: [],
  errors: [],
  activatedModArr: [],
  showErrors: false,
  activatedVariationMods: {},
  creationModPreset: null,
  modsTabVariationId: null,
};

export interface ExperienceStateIssue {
  error: boolean;
  key: string;
  type: "warning" | "error";
  customMessage?: string;
  docLink?: string;
  openDialog?: {
    linkText: string;
    payload?: OpenDialogAction["payload"];
  };
}
